const CompartirIcon = ({ color }) => {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5762 15.271L6.4662 12.484C5.97569 12.9709 5.35201 13.3017 4.67379 13.4346C3.99557 13.5676 3.29316 13.4968 2.65513 13.2311C2.01709 12.9654 1.47199 12.5168 1.08855 11.9418C0.705108 11.3668 0.500488 10.6911 0.500488 9.99999C0.500488 9.30886 0.705108 8.63319 1.08855 8.05818C1.47199 7.48317 2.01709 7.03455 2.65513 6.76889C3.29316 6.50322 3.99557 6.43241 4.67379 6.56536C5.35201 6.69832 5.97569 7.02909 6.4662 7.51599L11.5762 4.72899C11.4009 3.90672 11.5275 3.04885 11.9328 2.31224C12.3381 1.57563 12.9949 1.00952 13.7833 0.717422C14.5717 0.425324 15.4388 0.426763 16.2262 0.721475C17.0136 1.01619 17.6686 1.58448 18.0714 2.32243C18.4742 3.06037 18.598 3.91866 18.42 4.74034C18.242 5.56202 17.7742 6.29218 17.1021 6.79729C16.43 7.3024 15.5986 7.54871 14.7598 7.49119C13.9211 7.43366 13.131 7.07613 12.5342 6.48399L7.4242 9.27099C7.52613 9.75164 7.52613 10.2483 7.4242 10.729L12.5342 13.516C13.131 12.9238 13.9211 12.5663 14.7598 12.5088C15.5986 12.4513 16.43 12.6976 17.1021 13.2027C17.7742 13.7078 18.242 14.438 18.42 15.2596C18.598 16.0813 18.4742 16.9396 18.0714 17.6776C17.6686 18.4155 17.0136 18.9838 16.2262 19.2785C15.4388 19.5732 14.5717 19.5747 13.7833 19.2826C12.9949 18.9905 12.3381 18.4243 11.9328 17.6877C11.5275 16.9511 11.4009 16.0933 11.5762 15.271Z"
        fill="#006299"
      />
    </svg>
  );
};

export default CompartirIcon;
